import React, { Component } from "react";
import { View, ScrollView, Text, SafeAreaView, TouchableOpacity } from 'react-native';
import { connect } from "react-redux";
import Header from "../../../components/Header";
import styles from "../../../styles";
import { changeUserProfile } from "../../../action";
import { global, colors, action } from "../../../const";
import { PrimaryCaption, PrimaryTitle, LinkIndigo } from "../../../components/labels";
import { TextInput, Button } from "../../../components/form";
import SuccessDialog from "../../../components/modal/SuccessDialog";
import localize from "../../../localize";

class UpdateNickname extends Component {

    static navigationOptions = () => {
        return {
            title: localize.Change_Nickname
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            newName: '',
            errorMessage: null,
            isVisible: false,
        }
    }

    onChange = async (newName) => {
        this.setState({ newName, errorMessage: null });
    }

    onUpdateNickname = async () => {
        let { newName, errorMessage } = this.state;
        if (errorMessage !== null) return
        this.props.isLoading(true);
        let res = await this.props.changeUserProfile({ cmd: "WcnUser1.changeNickName", nickname: newName })
        this.props.isLoading(false);
        setTimeout(() => {
            switch (res) {
                case 200: return this.setState({ isVisible: true })
                case 1: return this.setState({ errorMessage: localize.Length_is_not_valid })
                case 2: return this.setState({ errorMessage: localize.only_letters_and_numbers_are_allowed_to_use })
                case 3: return this.setState({ errorMessage: localize.name_is_already_taken_by_others })
                case 4: return this.setState({ errorMessage: localize.abuse_detected_in_name })
                case 8: return this.setState({ errorMessage: localize.name_is_locked_by_someone_else_who_is_trying_to_change_the_name_at_same_time })
                default: return this.setState({ errorMessage: localize.Internal_server_error_please_try_again })
            }
        }, 300);
    }

    render() {
        const { newName, errorMessage, isVisible } = this.state;
        const { nickname } = this.props.userInfo;

        return (
            <SafeAreaView style={styles.container}>
                <Header title={localize.Change_Nickname} goBack={() => this.props.history.goBack()} hidden={global.isNative} />
                <ScrollView style={!global.isNative ? { height: this.props.height - 70 } : null} keyboardShouldPersistTaps="handled">
                    <View style={{ marginVertical: 20, marginHorizontal: 20 }}>
                        <PrimaryTitle>
                            {localize.To_set_a_new_name_please_enter_your_new_name_here}
                        </PrimaryTitle>
                        <View style={{ height: 30 }} />
                        <PrimaryCaption>
                            {localize.current_nickname}
                        </PrimaryCaption>
                        <View style={{ height: 5 }} />
                        <PrimaryTitle color={colors.gray}>
                            {nickname || ""}
                        </PrimaryTitle>
                        <View style={{ height: 30 }} />
                        <TextInput
                            title={localize.new_nickname}
                            placeholder={localize.new_nickname}
                            keyboardType="default"
                            value={newName}
                            onChangeText={this.onChange}
                            error={newName !== '' && errorMessage}
                            onSubmitEditing={this.onUpdateNickname}
                        />
                        <View style={{ height: 30 }} />
                        <Button
                            title={localize.change}
                            disabled={errorMessage !== null || newName === '' ? true : false}
                            onPress={this.onUpdateNickname}
                        />
                        <View style={{ paddingVertical: 30 }}>
                            <TouchableOpacity
                                onPress={() => global.isNative ? this.props.navigation.goBack() : this.props.history.goBack()}
                                style={{ alignSelf: "center", marginVertical: 10, marginHorizontal: 20 }}
                            >
                                <LinkIndigo>
                                    {localize.cancel}
                            </LinkIndigo>
                            </TouchableOpacity>
                        </View>
                    </View>
                </ScrollView>
                <SuccessDialog
                    isVisible={isVisible}
                    onCancel={() => this.setState({ isVisible: false, newName: '' })}
                    buttonTitle={localize.Ok}
                    buttonAction={() => this.setState({ isVisible: false, newName: '' })}
                    title={localize.Nickname_address_has_been_changed}
                />
            </SafeAreaView>
        );
    }

}

const mapStateToProps = ({ setting, auth }) => {
    return {
        height: setting.height,
        userInfo: auth.userInfo,
    };
}
const mapDispatch = (dispatch) => {
    return {
        changeUserProfile: request => dispatch(changeUserProfile(request)),
        isLoading: (status) => dispatch({ type: status ? action.LOADING_DIALOG_TRUE : action.LOADING_DIALOG_FALSE }),
    }
}
export default connect(mapStateToProps, mapDispatch)(UpdateNickname);